import React, { useState } from 'react';
import { Button } from '../../globalStyles';
import { AiFillThunderbolt } from 'react-icons/ai';
import { GiElevator } from 'react-icons/gi';
import { GiCutDiamond, GiRock } from 'react-icons/gi';
import { GrElevator, GrEscalator, GrConfigure } from 'react-icons/gr';
import { IconContext } from 'react-icons/lib';
// import {  Row, Col, Container } from 'react-modal'


import {
ButtonActionContainer,
ButtonAction,
  PricingSection,
  PricingWrapper,

  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  PricingCardCost,
  PricingCardLength,
  PricingCardFeatures,
  PricingCardFeature
} from './Pricing.elements';

function Pricing() {


  return (
    <IconContext.Provider value={{ color: '#eb594c', size: 80 }}>
      <PricingSection>
        <PricingWrapper>
          <PricingHeading>Our Services</PricingHeading>
          <PricingContainer>
            <PricingCard to='/elevators'>
              <PricingCardInfo>
                              <PricingCardPlan>Elevators</PricingCardPlan>

                <PricingCardIcon>
                  <GrElevator />
                </PricingCardIcon>
                {/* <PricingCardCost>$99.99</PricingCardCost> */}
                {/* <PricingCardLength>per month</PricingCardLength> */}
                <PricingCardFeatures>

                  {/* <PricingCardFeature>$10,000 Budget</PricingCardFeature>
                  <PricingCardFeature>Retargeting analytics</PricingCardFeature> */}
                </PricingCardFeatures>

                <Button primary>Learn more</Button>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard to='/escalators'>
              <PricingCardInfo>
                              <PricingCardPlan>Escalators</PricingCardPlan>

                <PricingCardIcon>
                  <GrEscalator />
                </PricingCardIcon>
                {/* <PricingCardCost>$299.99</PricingCardCost> */}
                {/* <PricingCardLength>per month</PricingCardLength> */}
                <PricingCardFeatures>
                  {/* <PricingCardFeature>$50,000 Budget</PricingCardFeature>
                  <PricingCardFeature>Lead Gen Analytics</PricingCardFeature> */}
                </PricingCardFeatures>
                <Button primary>Learn more</Button>
              </PricingCardInfo>
            </PricingCard>
            <PricingCard to='/maintainance'>
              <PricingCardInfo>
                              <PricingCardPlan>Maitainance</PricingCardPlan>

                <PricingCardIcon>
                  <GrConfigure />
                </PricingCardIcon>
                {/* <PricingCardCost>$999.99</PricingCardCost> */}
                {/* <PricingCardLength>per month</PricingCardLength> */}
                <PricingCardFeatures>
              
                  {/* <PricingCardFeature>Unlimited Budget</PricingCardFeature>
                  <PricingCardFeature>24/7 Support</PricingCardFeature> */}
                </PricingCardFeatures>
                <Button primary>Learn more</Button>
              </PricingCardInfo>
            </PricingCard>
          </PricingContainer>
        </PricingWrapper>
      </PricingSection>
    </IconContext.Provider>
    
  );
}
export default Pricing;
